import { formatTimeRange } from '../../../../utils/time';
import { format } from 'date-fns';
import { Button } from '../../../../components/ui/button';
import { Trash } from 'lucide-react';
import { memo, useState } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteDayOff } from '../../../../api/dayoff';
import toastifyInstance from '../../../../utils/toastify';
import AlertComponent from '../../../../components/alert';
import CreateDayOff from './create-day-off';

const DayOffItem = ({
    item,
}: {
    item: {
        _id: string;
        startDate: string;
        endDate: string;
        reason: string;
        note: string;
    };
}) => {
    const [open, setOpen] = useState(false);

    const queryClient = useQueryClient();

    const handleDelete = useMutation({
        mutationFn: async () => {
            await deleteDayOff(item._id);
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['day-off'] });
            toastifyInstance.success('Day off deleted successfully');
        },
        onError: (error) => {
            console.log(error);
            toastifyInstance.error('Failed to delete day off');
        },
        onSettled: () => {
            setOpen(false);
        },
    });

    return (
        <div
            key={item._id}
            className="border-b border-gray-200 rounded-md p-5 shadow-lg w-[max-content] flex"
        >
            <div>
                <div className="flex justify-between items-center">
                    <p className="text-sm font-bold">
                        {formatTimeRange(item.startDate, item.endDate)}
                    </p>
                </div>
                <div className="">
                    <p className="text-sm font-normal">{item.reason}</p>
                    <p className="text-sm italic text-gray-500">
                        {item.note ? `"${item.note}"` : ''}
                    </p>
                </div>
            </div>
            {
                <div className="ml-auto ms-4 flex gap-2 flex-col justify-between">
                    {format(new Date(item.startDate), 'yyyy-MM-dd') >
                        format(new Date(), 'yyyy-MM-dd') && (
                        <Button
                            className="rounded-full active:shadow-inner"
                            size="icon"
                        >
                            <CreateDayOff item={item} update={true} />
                        </Button>
                    )}
                    <AlertComponent
                        open={open}
                        title="Xoá ngày nghỉ?"
                        description={`Xác nhận xóa ngày nghỉ ${formatTimeRange(item.startDate, item.endDate)}`}
                        showButton={
                            <Button
                                className="rounded-full"
                                size="icon"
                                onClick={() => setOpen(true)}
                            >
                                <Trash className="text-red-500" />
                            </Button>
                        }
                    >
                        <div className="flex gap-2">
                            <Button onClick={() => handleDelete.mutate()}>
                                <p className="text-red-500">Delete</p>
                            </Button>
                            <Button onClick={() => setOpen(false)}>
                                <p className="text-gray-500">Cancel</p>
                            </Button>
                        </div>
                    </AlertComponent>
                </div>
            }
        </div>
    );
};

export default memo(DayOffItem);
